module.exports = __webpack_public_path__ + "img/charme_dark_grey_ba_list.47d3a939.jpg";